import React, {Component} from "react";
import "./Home.css";

import Hero from "./Hero/Hero";
import ProjectsNew from "./ProjectsNew/ProjectsNew";
import About from "./About/About";
import Portfolio from "./Portfolio/Portfolio";
import Contact from "./Contact/Contact";
import Footer from "Footer/Footer";

import utils from "utils";

let scroll = 0;

export default class Home extends Component
{
	constructor()
	{
		super();
		//this.state = {scrollTop: 0};

		this.handleRef = this.handleRef.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.handleHeroRef = this.handleHeroRef.bind(this);
		this.handleAboutRef = this.handleAboutRef.bind(this);
		this.handlePortfolioRef = this.handlePortfolioRef.bind(this);
		this.handleContactRef = this.handleContactRef.bind(this);
		this.scrollToAbout = this.scrollToAbout.bind(this);
		this.scrollToSection = this.scrollToSection.bind(this);
	}

	handleRef(ref)
	{
		this.ref = ref;

		if(this.ref)
		{
			this.ref.scrollTo(0, scroll);
		}
	}

	handleScroll(event)
	{
		scroll = this.ref ? this.ref.scrollTop : 0;
		//this.setState({scroll: this.ref.scrollTop || 0});
		//console.log(event);
		//this.setState({scrollTop: this.ref.scrollTop});
	}

	handleHeroRef(ref)
	{
		this.heroRef = ref;
	}

	handleAboutRef(ref)
	{
		this.aboutRef = ref;
	}

	handlePortfolioRef(ref)
	{
		this.portfolioRef = ref;
	}

	handleContactRef(ref)
	{
		this.contactRef = ref;
	}

	scrollToAbout()
	{
		utils.scrollTo(this.aboutRef);
	}

	scrollToSection(section)
	{
		let elem;

		if(section === "Home")
			elem = this.heroRef;
		else if(section === "About")
			elem = this.aboutRef;
		else if(section === "Portfolio")
			elem = this.portfolioRef;
		else if(section === "Contact")
			elem = this.contactRef;

		utils.scrollTo(elem);
	}

	render()
	{
		return (
			<div ref={this.handleRef} onScroll={this.handleScroll} className="home">
				{/*<DotPlay abc={5} scroll={this.state.scrollTop} />*/}

				<Hero
					handleRef={this.handleHeroRef}
					onScrollClick={this.scrollToAbout}
					scrollToSection={this.scrollToSection}
				/>

				{/*<ProjectsNew />*/}

				<About handleRef={this.handleAboutRef} />
				<Portfolio handleRef={this.handlePortfolioRef} />
				<Contact handleRef={this.handleContactRef} />
				<Footer />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.js